import React from 'react';
import { useAuthViewport } from './useAuthViewport';
import { TabletLayout } from './TabletLayout';
import { DesktopLayout } from './DesktopLayout';

export interface AuthTemplateProps {
  FormComponent: React.ComponentType;
}

/**
 * Auth template: desktop layout (illustration panel beside the form) or tablet
 * layout (illustration panel above the form) for viewport width ≤ 1023px.
 */
const AuthTemplate = ({ FormComponent }: AuthTemplateProps) => {
  const { isTablet } = useAuthViewport();

  if (isTablet) {
    return <TabletLayout FormComponent={FormComponent} />;
  }

  return <DesktopLayout FormComponent={FormComponent} />;
};

export default AuthTemplate;
